import { AxiosResponse } from "axios";
import { HttpMethods } from "../httpMethods";
import { Controllers, GeneralRoutes, TemplateApiRoutes, TemplateRoutes } from "src/utils/constants";
import { ApiTemplates } from ".";
import { Template, TemplateDeleteData, TemplateType } from "src/types/templates";
import { BaseService } from "../baseService";

export class TemplateService extends BaseService implements ApiTemplates {
    async getDefaultFont(): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.Templates, TemplateApiRoutes.Messaging);
    }
	
    async getMessagingTemplates(): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.Templates, TemplateApiRoutes.Messaging);
    }

    async getVoiceTemplates(): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.Templates, TemplateApiRoutes.Voice);
    }

    async getAiAgentSystemPromptTemplates(): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.Templates, TemplateApiRoutes.AIAgentSystemPrompts);
    }

    async getAiSummaryTemplates(): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.Templates, TemplateApiRoutes.AiSummary);
    }

    async getTemplatesByQueueId(queueId: string): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.Templates, queueId);
    }

    async create(template: Template): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.Templates, GeneralRoutes.Create, null, template);
    }

    async getById(templateId: string): Promise<AxiosResponse<any, any>> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.Templates, '', `${templateId}`);
    }

    async update(template: Template): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.Templates, GeneralRoutes.Update, null, template);
    }

    async getTemplateList(urlParams: string): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.Templates, GeneralRoutes.List, urlParams);
    }

    async deleteTemplates(data: TemplateDeleteData): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.Templates, GeneralRoutes.Delete, null, data);
    }

    async testPrompt(prompt: string, templateType: TemplateType): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.Templates, `${TemplateRoutes.TestPrompt}/${templateType}`, null, prompt);
    }

    async getVariables(): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.Templates, TemplateRoutes.GetVariables);
    }
}